import { useCallback, useMemo } from 'react'
import type { AccountDetailsFormInput } from '@/wallet/types'
import { useFetchAccountDetails, useSaveAccountDetails } from '@/wallet/walletQueries'
import { BankAccountFormValues } from '@/onboarding/features/bank-account/rules/bankAccountSchema'
import useAccountStore from '@/account/accountStore'

type Result = {
    data: AccountDetailsFormInput | undefined
    loading: boolean
    saving: boolean
    isSuccess: boolean
    onSubmit: (data: BankAccountFormValues) => void
}

export function useBankAccountLogic(): Result {
    const activeAccountId = useAccountStore((s) => s.activeAccountId)
    const { data: withdrawalAccount, isLoading: fetchingAccountDetails } = useFetchAccountDetails(activeAccountId)
    const saveAccountDetails = useSaveAccountDetails()

    const accountData = useMemo(() => {
        if (!withdrawalAccount) return undefined
        return {
            bankAccountName: withdrawalAccount.bankAccountName,
            bsb: withdrawalAccount.bsb,
            bankAccountNumber: withdrawalAccount.bankAccountNumber,
        }
    }, [withdrawalAccount])

    const loading = fetchingAccountDetails

    const onSubmit = useCallback(
        (data: BankAccountFormValues) => {
            saveAccountDetails.mutate({ ...data, bsb: data.bsb.replace(/[\s-]/g, '') })
        },
        [saveAccountDetails],
    )

    return {
        data: accountData,
        loading,
        saving: saveAccountDetails.isPending,
        isSuccess: saveAccountDetails.isSuccess,
        onSubmit,
    }
}
